<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="tab-content">
      <ValidationObserver v-slot="{ handleSubmit }">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="4" class="title">面談紀錄</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="width-15 text-right">姓名</td>
              <td class="width-35">
                {{ interviewee.Name }}
                <el-button size="mini" class="ml-2" @click="viewResume">
                  檢視履歷
                </el-button>
              </td>
              <td class="width-15 text-right">性別</td>
              <td class="width-35">{{ interviewee.Sex }}</td>
            </tr>

            <tr>
              <td class="width-15 text-right">應徵職務</td>
              <td class="width-35">
                {{ interviewee.Position }}
              </td>

              <td class="width-15 text-right">職等</td>
              <td class="width-35">
                <el-select
                  class="w-100"
                  :disabled="interviewee.ResumeType === 'DL'"
                  placeholder="請選擇"
                  v-model="form.ExpectedJobLevel"
                >
                  <el-option label="3" value="3" />
                  <el-option label="4" value="4" />
                  <el-option label="5" value="5" />
                  <el-option label="6" value="6" />
                  <el-option label="6.3" value="6.3" />
                  <el-option label="7" value="7" />
                  <el-option label="7.3" value="7.3" />
                  <el-option label="8" value="8" />
                  <el-option label="8.3" value="8.3" />
                  <el-option label="9" value="9" />
                  <el-option label="9.3" value="9.3" />
                  <el-option label="10" value="10" />
                  <el-option label="10.3" value="10.3" />
                  <el-option label="10.5" value="10.5" />
                  <el-option label="10.7" value="10.7" />
                  <el-option label="11" value="11" />
                  <el-option label="11.3" value="11.3" />
                  <el-option label="11.5" value="11.5" />
                  <el-option label="12" value="12" />
                  <el-option label="13" value="13" />
                  <el-option label="13.3" value="13.3" />
                </el-select>
              </td>
            </tr>

            <tr>
              <td class="text-right">測驗成績</td>
              <td colspan="3">
                <table class="table table-bordered">
                  <thead>
                    <tr class="text-center">
                      <th v-for="item in form.Scores" :key="item.Name">
                        {{ item.Name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <td
                      v-for="item in form.Scores"
                      :key="item.Name"
                      class="text-center"
                    >
                      {{ item.Score }}
                    </td>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td class="text-right">
                <span class="mark">*</span>
                面談評估
              </td>
              <td colspan="3">
                <table class="table table-bordered">
                  <tr>
                    <th></th>
                    <th class="text-center">是</th>
                    <th class="text-center">否</th>
                  </tr>
                  <template v-for="item in form.InterviewRecordAppraisals">
                    <tr :key="item.Name">
                      <td>{{ item.Name }}</td>
                      <td class="text-center">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <input
                            type="radio"
                            :value="true"
                            v-model="item.Result"
                          />
                          <span v-if="errors[0]" class="text-danger">
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </td>
                      <td class="text-center">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <input
                            type="radio"
                            :value="false"
                            v-model="item.Result"
                          />
                          <span v-if="errors[0]" class="text-danger">
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </td>
                    </tr>

                    <tr v-if="item.Result === false" :key="item.Id">
                      <td colspan="4">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <el-input
                            class="w-100"
                            type="textarea"
                            :rows="2"
                            maxlength="50"
                            show-word-limit
                            placeholder="備註"
                            v-model="item.Remark"
                          />
                          <span v-if="errors[0]" class="text-danger">
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </td>
                    </tr>
                  </template>
                </table>
              </td>
            </tr>

            <tr v-if="interviewee.ResumeType === 'IDL'">
              <td class="text-right">
                <span class="mark">*</span>所負義務<br />既有智財評估
              </td>
              <td colspan="3">
                本應徵者在履歷表上有聲明其所負義務/既有智財，謹此提供其聲明內容，供主管了解並作為是否任用之評估。
                <div>
                  說明：
                  <br />
                  1.
                  為強化智財風險管控，公司招募流程會請應徵者聲明其所負義務/既有智財，以了解應徵者是否對前雇主負有競業禁止或保密義務，及其曾取得或申請中的智財。
                  <br />
                  2.
                  由於應徵者的既有智財可能屬於其前雇主的資產，應徵者應遵守其與前雇主的保密義務。聘用應徵者之後，公司亦須注意監督，防止人員有侵害他人智財的行為。
                  <br />
                  3.
                  如對於是否任用的風險評估有疑問，敬請聯繫人資安排與法務進一步諮詢。
                  <br />
                  <ValidationProvider
                    :rules="{ required: { allowFalse: false } }"
                    v-slot="{ errors }"
                  >
                    <div style="display: flex">
                      <label>
                        <input
                          type="checkbox"
                          id="checkRiskControl"
                          name="checkRiskControl"
                          v-model="riskControlCheck"
                        />
                        <label for="checkRiskControl">
                          已考量並完成風險評估
                        </label>
                      </label>
                      <p
                        v-if="errors[0]"
                        class="text-danger"
                        style="margin-left: 20px"
                      >
                        請進行面談評估
                      </p>
                    </div>
                  </ValidationProvider>
                </div>
              </td>
            </tr>

            <tr>
              <td class="text-right"><span class="mark">*</span>面談說明</td>
              <td colspan="3">
                <div class="form-group">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <el-input
                      class="w-100"
                      type="textarea"
                      :rows="6"
                      maxlength="400"
                      show-word-limit
                      v-model="form.Remark"
                    />
                    <span v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
              </td>
            </tr>

            <tr>
              <td class="text-right"><span class="mark">*</span>面談結果</td>
              <td colspan="3">
                <ValidationProvider
                  rules="required"
                  name="面談結果"
                  v-slot="{ errors }"
                >
                  <div class="form-group">
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="錄取"
                        v-model="form.InterviewResult"
                      />
                      <label class="form-check-label" for="InterviewResult0">
                        錄取
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="考慮中"
                        v-model="form.InterviewResult"
                      />
                      <label class="form-check-label" for="InterviewResult0">
                        考慮中
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="複試"
                        v-model="form.InterviewResult"
                      />
                      <label class="form-check-label" for="InterviewResult0">
                        複試
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        value="不錄取"
                        v-model="form.InterviewResult"
                      />
                      <label class="form-check-label" for="InterviewResult0">
                        不錄取
                      </label>
                    </div>
                  </div>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </td>
            </tr>

            <tr>
              <td class="text-right">個人備註</td>
              <td colspan="3">
                <div class="form-group">
                  <el-input
                    class="w-100"
                    type="textarea"
                    :rows="6"
                    maxlength="800"
                    show-word-limit
                    v-model="form.PersonalRemark"
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td colspan="12" class="text-center">
                <button
                  type="button"
                  class="btn btn-secondary"
                  style="margin-right: 5px"
                  @click="goBack"
                >
                  返回
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(saveInterviewRecord)"
                >
                  儲存
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </ValidationObserver>
    </div>

    <!-- 基本履歷 -->
    <div
      id="resumeModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      data-focus="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content progress-resume-modal">
          <div class="modal-header">履歷</div>
          <perfect-scrollbar class="modal-body">
            <DlResume v-if="ResumeType === 'DL'" :ResumeId="ResumeId" />
            <IdlResume v-if="ResumeType === 'IDL'" :ResumeId="ResumeId" />
          </perfect-scrollbar>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "CreateInterviewRecord",

  components: {
    IdlResume,
    DlResume,
  },
  data() {
    return {
      interviewee: {},

      form: {},

      writeRecord: {},

      riskControlCheck: false,

      ResumeType: null,
      ResumeId: null,
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  methods: {
    // 取得 面談紀錄表
    getInterviewRecord() {
      this.updateLoading(true);
      this.$api.recruitment
        .postInterviewRecord({
          InterviewRecordId: this.interviewee.InterviewRecordId,
          InterviewId: this.interviewee.InterviewId,
        })
        .then((response) => {
          if (response.status === 200) {
            this.form = response.data;
          }
          this.updateLoading(false);
        });
    },

    // 新增面談紀錄 API
    saveInterviewRecord() {
      this.$api.recruitment
        .putInterviewRecord({
          ...this.form,
          InterviewId: this.interviewee.InterviewId,
          UpdateUser: this.$cookies.get("userName"),
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "面談紀錄已儲存",
              type: "success",
              duration: 2500,
            });
            this.$router.push({
              path: "/manager/recruitment/interviewhistory",
            });
          }
        });
    },

    // 檢視履歷
    viewResume() {
      this.ResumeType = this.interviewee.ResumeType;
      this.ResumeId = this.interviewee.ResumeId;
      $("#resumeModal").modal("show");
    },

    // 返回前頁
    goBack() {
      this.$router.back();
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.interviewee = JSON.parse(localStorage.getItem("INTERVIEWEE"));
    this.getInterviewRecord();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
$color1: #636f83;

.width-15 {
  width: 15%;
}
.width-35 {
  width: 35%;
}
.title {
  background-color: #636f83;
  color: #ffffff;
  text-align: center;
  font-weight: bolder;
}
.text-center {
  text-align: center;
}
.go-back {
  margin-top: 30px;
  border: none;
  font-size: 0.8em;
  background-color: #303c50;
  border-radius: 25px;
  padding: 6px 10px;
  color: #fff;
  i {
    margin-right: 5px;
  }
}
.tab-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 15px;
  max-width: 960px;
  margin: 0 auto;
}

input[type="radio"] {
  transform: scale(1.4);
  cursor: pointer;
  opacity: 0.3;
  &:checked {
    opacity: 1;
  }
}
</style>
